/** Mirrors `app/views/pages/code_snippets/user_jsx.txt` for the hero solutions panel. */
export const USER_SOLUTIONS_SNIPPET = `import React from 'react'

const UserDefault = () => {
  return (
    <User
        align="center"
        avatarUrl="https://randomuser.me/api/portraits/women/44.jpg"
        name="Anna Black"
        orientation="vertical"
        size="lg"
        title="Remodeling Consultant"
    />
  )
}

export default UserDefault`
